
  document.querySelectorAll('.cph-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('cph-main-image');
      var fullSrc = this.getAttribute('data-full-image');
      if (mainImg && fullSrc) { mainImg.src = fullSrc; }
      document.querySelectorAll('.cph-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  function cphUpdateBundleProgress(selectedEl) {
    var options = Array.prototype.slice.call(document.querySelectorAll('.cph-bundle-option'));
    var fill = document.getElementById('cph-bundle-progress-fill');
    var msg = document.getElementById('cph-bundle-progress-msg');
    if (!options.length || !fill || !msg || !selectedEl) return;

    var index = options.indexOf(selectedEl);
    var percent = ((index + 1) / options.length) * 100;
    fill.style.width = percent + '%';

    if (index === options.length - 1) {
      msg.textContent = "🎉 You've unlocked our best price!";
    } else {
      var next = options[index + 1];
      var nextLabel = next.getAttribute('data-label');
      var nextSubtext = next.getAttribute('data-subtext');
      msg.textContent = 'Switch to ' + nextLabel + (nextSubtext ? ' — ' + nextSubtext : '');
    }
  }

  function cphSelectBundle(el) {
    document.querySelectorAll('.cph-bundle-option').forEach(o => o.classList.remove('selected'));
    el.classList.add('selected');
    var qty = el.getAttribute('data-qty') || 1;
    var qtyInput = document.getElementById('cph-quantity-input');
    if (qtyInput) qtyInput.value = qty;

    var priceDisplay = el.getAttribute('data-price-display');
    var priceEl = document.getElementById('cph-cta-price');
    if (priceEl && priceDisplay) {
      priceEl.textContent = '\u2013 ' + priceDisplay;
    }

    var stickyPriceEl = document.getElementById('cph-sticky-price');
    if (stickyPriceEl && priceDisplay) {
      stickyPriceEl.textContent = priceDisplay;
    }

    cphUpdateBundleProgress(el);
  }

  document.addEventListener('DOMContentLoaded', function() {
    var selected = document.querySelector('.cph-bundle-option.selected') || document.querySelector('.cph-bundle-option');
    if (selected) cphSelectBundle(selected);
  });

  // Intercept the Add to Cart form: add via AJAX, then open the cart drawer instead of reloading the page.
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('cph-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('cph-cta-button');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding...</span>'; }

      cphAddToCartAjax(form, function() {
        refreshCartDrawer(function() {
          toggleCartDrawer(true);
          if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        });
      }, function() {
        if (btn) { btn.disabled = false; btn.innerHTML = originalText; }
        alert('Sorry, something went wrong adding this to your cart. Please try again.');
      });
    });
  });

  // Buy Now: add to cart via AJAX, then go straight to checkout (skips the drawer entirely).
  function cphBuyNow() {
    var form = document.getElementById('cph-product-form');
    var btn = document.getElementById('cph-buy-now-button');
    if (!form) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Redirecting...'; }

    cphAddToCartAjax(form, function() {
      window.location.href = '/checkout';
    }, function() {
      if (btn) { btn.disabled = false; btn.textContent = '⚡ Buy it now'; }
      alert('Sorry, something went wrong. Please try again.');
    });
  }

// Sticky mobile add-to-cart bar: shows only once the user has scrolled PAST the full
// buy box (trust badges + mini FAQ included), not before reaching it.
document.addEventListener('DOMContentLoaded', function() {
  var trigger = document.getElementById('cph-sticky-trigger');
  var stickyBar = document.getElementById('cph-sticky-bar');
  var floatingContact = document.querySelector('.floating-contact-btn');
  if (!trigger || !stickyBar || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // Only show once the trigger has scrolled ABOVE the viewport (top < 0) —
      // i.e. the user scrolled down past it — never while it's still below,
      // unscrolled-to.
      var scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      stickyBar.classList.toggle('visible', scrolledPast);
      if (floatingContact) {
        floatingContact.classList.toggle('sticky-bar-open', scrolledPast);
      }
    });
  }, { threshold: 0 });

  observer.observe(trigger);
});
